import React from "react";
import styled from "styled-components";
import { lightThemeColors } from "../../assets/style/colors";
import TitleDescriptionCard from "../generic/TitleDescriptionCard";
import { ReactComponent as ForkIcon5 } from "../../assets/icons/Fork5.svg";

const FirebaseWhy = () => {
  const items = [
    {
      title: "Drop-in SDKs, No Friction",
      description:
        "Our SDKs are designed for rapid integration via Swift Package Manager (SPM), CocoaPods, and Gradle. Get up and running in minutes with minimal configuration.",
    },

    {
      title: "True Cross-Platform Deep Linking",
      description:
        "Handle deep links across iOS, Android, and web with a single consistent API. Grovs makes it easy to route users directly to in-app content or guide them through smooth install flows.",
    },

    {
      title: "Built for Marketers & Developers",
      description:
        "From no-code link builders to developer-friendly APIs, Grovs empowers your whole team. Track, attribute, and optimize every touchpoint—no engineering bottlenecks.",
    },

    {
      title: "Comprehensive Analytics",
      description:
        "Go beyond click counts. Grovs delivers actionable insights into link performance, user behavior, and attribution—so you can make smarter decisions, faster.",
    },
  ];
  return (
    <FullPageContainer>
      <Container id={"userJourney"}>
        <Content>
          <TextWrapper>
            <Title>Why Make the Move to Grovs?</Title>
            <Subtitle>
              Grovs is built for modern teams who want reliable, flexible, and
              out-of-the-box deep linking that just works. Whether you’re
              managing campaigns or building product experiences, Grovs replaces
              Firebase Dynamic Links with{" "}
              <b>zero compromise—and plenty of gains</b>.
            </Subtitle>
          </TextWrapper>
          <RightSide>
            <ForkWrapper>
              <ForkIcon5 color="rgba(11, 39, 44, 0.55)" />
            </ForkWrapper>
            <ItemsWrapper>
              {items.map((item, index) => (
                <TitleDescriptionCard
                  key={index}
                  title={item.title}
                  description={item.description}
                />
              ))}
            </ItemsWrapper>
          </RightSide>
        </Content>
      </Container>
    </FullPageContainer>
  );
};

export default FirebaseWhy;
const FullPageContainer = styled.div`
  display: flex;
  width: 100%;
  background: ${lightThemeColors.background};
  position: relative;
`;

const Container = styled.div`
  width: 100%;
  max-width: 1512px;
  margin-left: auto;
  margin-right: auto;
  z-index: 1;
  display: flex;
  flex-direction: column;
  padding: 100px 80px;
  gap: 100px;
  @media (max-width: 990px) {
    padding: 20px;
    gap: 30px;
  }
`;
const Content = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  gap: 30px;
  align-items: center;
  @media (max-width: 990px) {
    flex-direction: column;
  }
`;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 30px;
  max-width: 850px;
  @media (max-width: 990px) {
    max-width: unset;
  }
`;

const Title = styled.h1`
  color: ${lightThemeColors.darkColor};
  font-size: 36px;
  font-weight: 700;
  line-height: 46px;
  @media (max-width: 990px) {
    font-size: 30px;
    line-height: 36px;
    text-align: center;
  }
`;
const Subtitle = styled.p`
  color: ${lightThemeColors.darkColorFaded};
  font-size: 18px;
  font-weight: 400;
  line-height: 28px;
  @media (max-width: 990px) {
    font-size: 18px;
    line-height: 24px;
    text-align: center;
  }
`;
const ItemsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  overflow: hidden;
`;
const RightSide = styled.div`
  display: flex;
  align-items: center;
  height: 100%;
  width: 100%;
  gap: 10px;
`;
const ForkWrapper = styled.div`
  display: flex;
  align-items: center;
  height: 100%;
  @media (max-width: 990px) {
    display: none;
  }
`;
